import React from 'react'
import { Link } from 'react-router-dom'
import { Grid, Typography } from '@mui/material'

const SideBar = () => {
  return (
    <Grid container direction='column'>
      <Grid item>
        <Grid container direction='column'>
          <Grid item>
            <Typography variant='h6'>Quick menu</Typography>
          </Grid>

          <Grid item>
            <Link to='/admin/dashboard'>Booked lessons list</Link>
          </Grid>

          <Grid item>
            <Link to='/admin/somethingElse'>Something else</Link>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default SideBar
